import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { delay, firstValueFrom, Observable, Subject, takeUntil } from 'rxjs';
import { Common } from '../lib/common-methods';
import { ReservationService } from '../lib/reservation.service';
import { Reservation, ReservationStatus } from '../model/reservation';
import * as ReservationActions from '../store/actions/reservation.actions';
import * as ReservationSelectors from '../store/selectors/reservation.selectors';
declare const bootstrap: any;

@Component({
  selector: 'app-reservation-status-modal',
  templateUrl: './reservation-status-modal.component.html',
  styleUrls: ['./reservation-status-modal.component.scss']
})
export class ReservationStatusModalComponent implements OnInit, AfterViewInit, OnDestroy {

  constructor(private translate: TranslateService, private reservationService: ReservationService, private store: Store<{ reservations: Reservation[] }>) { }

  destroy$: Subject<boolean> = new Subject<boolean>();

  @ViewChild('modalStatus') modalStatus: ElementRef | null = null;

  lang: string = 'en';
  changeStatusReservation$: Observable<Reservation | null | undefined> = this.store.pipe(select(ReservationSelectors.selectReservation));
  changeStatusReservation: Reservation | null | undefined = null;
  quickChangingStatus$: Observable<boolean> = this.store.pipe(select(ReservationSelectors.selectQuickChangingStatus));

  relevantStatuses: { id: ReservationStatus, img: string }[] = [];
  lessReleventStatuses: { id: ReservationStatus, img: string }[] = [];

  ngOnInit(): void {

    this.lang = this.translate.currentLang;

    this.quickChangingStatus$.pipe(delay(250), takeUntil(this.destroy$)).subscribe(async (quickChangingStatus) => {

      if (!quickChangingStatus) {
        return;
      }

      this.changeStatusReservation = await firstValueFrom(this.changeStatusReservation$);

      if (this.changeStatusReservation == null) {
        return;
      }

      const relevantStatusIds: ReservationStatus[] = this.reservationService.getStatusTransitions(this.changeStatusReservation?.reservationDetails?.reservationsStatus);

      this.relevantStatuses = this.reservationService.getFilteredReservationStatuses().filter(status => relevantStatusIds.includes(status.id))
        .sort((a: { id: ReservationStatus, img: string }, b: { id: ReservationStatus, img: string }) => {

          const aIndex = relevantStatusIds.indexOf(a.id);
          const bIndex = relevantStatusIds.indexOf(b.id);

          if (aIndex > bIndex) {
            return 1;
          }

          if (aIndex < bIndex) {
            return -1;
          }

          return 0;
        });
      this.lessReleventStatuses = this.reservationService.getFilteredReservationStatuses().filter(status => !relevantStatusIds.includes(status.id));

      // show modal
      const modalInstance = new bootstrap.Modal(this.modalStatus?.nativeElement);
      if (modalInstance) {
        modalInstance.show();
      }

    });

  }

  ngAfterViewInit(): void {
    this.modalStatus?.nativeElement.addEventListener('hidden.bs.modal', (event: Event) => {
      this.store.dispatch({ type: ReservationActions.setHideQuickChangeStatus.type });
    })
  }

  changeStatus(status: ReservationStatus) {
    if (this.changeStatusReservation == null) {
      return;
    }

    this.store.dispatch({ type: ReservationActions.setHideQuickChangeStatus.type });
    this.store.dispatch({ type: ReservationActions.setReservationStatus.type, status });
    this.store.dispatch({ type: ReservationActions.submitReservation.type, reservation: this.changeStatusReservation });
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

}
